import { Component} from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, ModalController, AlertController, ToastController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';

/**
 * Generated class for the StakingcompletePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-stakingcomplete',
  templateUrl: 'stakingcomplete.html',
})
export class StakingcompletePage {

    loginId: string;
	api_key: string;
	version: string;
	language : string;
	email: string;

	value: string;
    
    coin_unit: string;
    unit: string;
    
    texts: any = [];

    isSend : boolean = true;

    constructor(
		public navCtrl: NavController,
		public navParams: NavParams,
        public viewCtrl: ViewController,
		private http: HttpService,
		public modalCtrl: ModalController,
		public alertCtrl:AlertController,
		public toastCtrl: ToastController,
		public app: App
    ) {
        this.value = this.navParams.get("value");
	}

    ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		// this.api_key = localStorage.getItem("api_key");
		// this.loginId = localStorage.getItem("loginId");
		// if(!this.api_key) {
		// 	this.app.getRootNav().setRoot(LoginPage);
		// }

		//// 페이지 이름
		localStorage.setItem("pageName", "stakingcomplete");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
        this.email = localStorage.getItem("email");
        this.coin_unit = localStorage.getItem("coin_unit");
        this.unit = localStorage.getItem("unit");

        this._get_texts();

        // this._init();
        
    }

    _get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).stakingcomplete;
	}

    _cancel() {
        this.viewCtrl.dismiss("ok");
    }
}



// WEBPACK FOOTER //
// ./src/pages/stakingcomplete/stakingcomplete.ts